export function getBlurAnimation (element, settings) {
    const animation = {
        filter: `blur(${settings.blur}em)`,
    }
    if (settings.withFade) {
        animation.opacity = 0
    }
    return animation
}
